export default e => {
  e.preventDefault();
  e.stopPropagation();
  const [, id] = e.currentTarget.href.split('#');
  const element = document.getElementById(id);
  element.scrollIntoView();
};
